import { Link, useNavigate } from "react-router-dom";
import { Minus, Plus, X } from "lucide-react";
import { useTheme } from "../context/ThemeContext";
import { useCart } from "../context/CartContext";
import { api } from "../lib/api";
import { toast } from "sonner";

export default function Cart() {
  const t = useTheme();
  const nav = useNavigate();
  const { items, setQty, remove, total, clear } = useCart();
  const checkout = async () => {
    if (!items.length) return;
    try {
      const { data } = await api.post("/checkout/session", {
        items: items.map(i => ({ id: i.slug, qty: i.qty })),
        origin_url: `${window.location.origin}`,
        kind: "cart",
      });
      window.location.href = data.url;
    } catch { toast.error("Could not start checkout"); }
  };
  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16" data-testid="cart-page">
      <div className="text-[11px] tracking-[0.4em] uppercase opacity-70" style={{ color: t.primary }}>Cart</div>
      <h1 className="mt-3 text-5xl" style={{ color: t.text }}>Your bag</h1>
      {items.length === 0 ? (
        <div className="mt-10" data-testid="cart-empty">
          <p className="opacity-75">Your bag is empty.</p>
          <Link to={`/`} className={`mt-6 inline-block px-6 py-3 text-xs tracking-[0.3em] uppercase ${t.btnPrimary}`}>Back to home</Link>
        </div>
      ) : (
        <div className="mt-10 grid md:grid-cols-3 gap-10">
          <ul className="md:col-span-2 divide-y">
            {items.map(i => (
              <li key={i.slug} className="py-6 flex gap-4 items-center" data-testid={`cart-item-${i.slug}`}>
                <img src={i.image} alt={i.name} className="w-24 h-24 object-cover" />
                <div className="flex-1">
                  <div className="text-lg" style={{ fontFamily: t.location === 'ocala' ? "'Cormorant Garamond', serif" : "'Archivo', sans-serif", color: t.text }}>{i.name}</div>
                  <div className="text-sm opacity-75 mt-1">${i.price.toFixed(2)}</div>
                  <div className={`mt-2 inline-flex items-center border ${t.accentBorder}`}>
                    <button onClick={() => setQty(i.slug, i.qty - 1)} className="px-3 py-2"><Minus className="w-3 h-3" /></button>
                    <span className="px-4 text-sm">{i.qty}</span>
                    <button onClick={() => setQty(i.slug, i.qty + 1)} className="px-3 py-2"><Plus className="w-3 h-3" /></button>
                  </div>
                </div>
                <div className="text-right">
                  <div>${(i.price * i.qty).toFixed(2)}</div>
                  <button onClick={() => remove(i.slug)} className="mt-2 opacity-60" data-testid={`cart-remove-${i.slug}`}><X className="w-4 h-4" /></button>
                </div>
              </li>
            ))}
          </ul>
          <aside className={`p-6 bg-white border ${t.accentBorder} h-fit`} style={{ borderBottom: t.location === 'miami' ? `3px solid ${t.primary}` : undefined }}>
            <h2 className="text-2xl" style={{ color: t.text }}>Order summary</h2>
            <div className="mt-6 flex justify-between text-sm"><span>Subtotal</span><span>${total.toFixed(2)}</span></div>
            <div className="flex justify-between text-sm opacity-70"><span>Shipping</span><span>Calculated next</span></div>
            <div className="mt-4 pt-4 border-t flex justify-between text-lg" style={{ color: t.primary }}><span>Total</span><span>${total.toFixed(2)}</span></div>
            <button onClick={checkout} className={`mt-6 w-full px-6 py-4 text-xs tracking-[0.3em] uppercase ${t.btnPrimary}`} data-testid="cart-checkout">Checkout with Stripe</button>
            <button onClick={clear} className="mt-3 w-full text-xs uppercase tracking-[0.2em] opacity-60">Clear cart</button>
          </aside>
        </div>
      )}
    </div>
  );
}
